export const contentList = {
  title: 'My Contents',
  subtitle: '{{count}} contents',
  subtitleSingular: '1 content',
  newContent: 'New content',
  search: {
    placeholder: 'Search by title or keyword...',
  },
  findReplace: {
    toggle: 'Find & replace',
    searchPlaceholder: 'Term to find...',
    replacePlaceholder: 'Replace with...',
    matchCase: 'Match case',
    replace: 'Replace',
    replaceCurrentAriaLabel: 'Replace the current match',
    replaceAll: 'Replace all',
    counter: '{{current}}/{{total}}',
    previousMatch: 'Previous match',
    nextMatch: 'Next match',
    close: 'Close',
    noMatches: 'No matches',
    replacedToast: 'Replaced {{occurrences}} matches',
  },
  filters: {
    statusPlaceholder: 'Filter by status',
    all: 'All statuses',
    tagPlaceholder: 'Filter by tags',
    tagsSelected: '{{count}} tags',
    clearTags: 'Clear tags',
    sortPlaceholder: 'Sort by',
    sortNewest: 'Newest',
    sortOldest: 'Oldest',
    sortTitle: 'Title A-Z',
  },
  folders: {
    sectionTitle: 'Folders',
    itemCount: '{{count}} items',
    itemCountSingular: '1 item',
    emptyFolder: 'This folder is empty',
    emptyFolderDescription: 'Move content here or create new content',
    createFolder: 'New folder',
    rename: 'Rename',
    delete: 'Delete',
    deleteConfirmTitle: 'Delete folder?',
    deleteConfirmDescription: 'Contents inside this folder will not be deleted, they will become unorganized.',
    renameTitle: 'Rename folder',
    renamePlaceholder: 'Folder name',
    renameConfirm: 'Rename',
    folder: 'Folder',
    item: 'item',
    items: 'items',
  },
  breadcrumb: {
    allContents: 'All Contents',
  },
  selection: {
    itemsSelected: '{{count}} selected',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    moveToFolder: 'Move to folder',
    removeFromFolder: 'Remove from folder',
    moveSuccess: 'Contents moved successfully',
    removeSuccess: 'Contents removed from folder',
    moveError: 'Failed to move contents',
    addTags: 'Add tags',
    removeTags: 'Remove tags',
    bulkAddTags: 'Add tags to selected',
    bulkRemoveTags: 'Remove tags from selected',
    bulkAddTagsDescription: 'Select tags to add to all selected contents',
    bulkRemoveTagsDescription: 'Select tags to remove from all selected contents',
    addTagsConfirm: 'Add tags',
    removeTagsConfirm: 'Remove tags',
    tagsSelectedCount: '{{count}} tags selected',
    addTagsSuccess: 'Tags added successfully',
    removeTagsSuccess: 'Tags removed successfully',
    tagsError: 'Failed to update tags',
  },
  moveDialog: {
    title: 'Move to folder',
    searchPlaceholder: 'Search folders...',
    noFolders: 'No folders yet',
    createNewFolder: 'Create new folder',
    confirm: 'Move',
    cancel: 'Cancel',
  },
  viewMode: {
    grid: 'Grid view',
    table: 'Table view',
  },
  table: {
    columns: {
      title: 'Title',
      keyword: 'Keyword',
      status: 'Status',
      entity: 'Entity',
      date: 'Date',
      actions: 'Actions',
    },
  },
  status: {
    generating: 'Generating',
    completed: 'Completed',
    failed: 'Failed',
  },
  time: {
    justNow: 'Just now',
    minutesAgo: '{{minutes}}m ago',
    hoursAgo: '{{hours}}h ago',
    daysAgo: '{{days}}d ago',
  },
  actions: {
    open: 'Open',
    delete: 'Delete',
    moveToFolder: 'Move to folder',
  },
  empty: {
    title: 'No contents yet',
    description: 'Start by generating your first SEO and GEO optimized content with artificial intelligence.',
    createButton: 'Create content',
  },
  error: {
    title: 'Failed to load',
    description: 'We could not load your contents. Please try again.',
  },
  pagination: {
    previous: 'Previous',
    next: 'Next',
    pageOf: 'Page {{page}} of {{totalPages}}',
    showing: 'Showing {{from}}-{{to}} of {{total}}',
  },
  deleteConfirm: {
    title: 'Delete content?',
    description:
      'This action cannot be undone. The content and all its versions will be permanently deleted.',
    cancel: 'Cancel',
    confirm: 'Delete',
    success: 'Content deleted successfully',
    error: 'Failed to delete content',
  },
  tabs: {
    close: 'Close tab',
    newTab: 'Open another content',
    searchPlaceholder: 'Search content...',
    empty: 'No content to open',
    noResults: 'No results for "{{search}}"',
    alreadyOpen: 'Open',
    noFolder: 'No folder',
  },
  detail: {
    title: 'Content Detail',
    backToList: 'Back to list',
    notFound: {
      title: 'Content not found',
      description: 'The content you are looking for does not exist or was deleted.',
    },
    generating: {
      title: 'Generating content...',
      description: 'The content is being processed. This page will update automatically.',
    },
    generationError: {
      title: 'Generation error',
    },
    generatedSuccess: 'Content generated successfully!',
    regeneratingFromInput: 'Regenerating content from original input...',
    titleUpdateSuccess: 'Title updated',
    titleUpdateError: 'Failed to update title: {{message}}',
    improve: 'Improve',
    improving: 'Improving...',
    tabs: {
      content: 'Content',
    },
    seoScore: {
      criteriaToImprove: '{{count}} criteria to improve',
      allPassed: 'All criteria passed',
      showDetail: 'Show detail',
      hideDetail: 'Hide detail',
    },
    showLess: 'Show less',
    sections: {
      brief: 'Brief',
      contentInfo: 'Content Information',
      seoVerification: 'Verification',
      reliability: 'Content Reliability',
    },
    references: {
      internal: 'Internal',
      external: 'External',
    },
    fields: {
      mainEntity: 'Main Entity',
      language: 'Language',
      brandVoice: 'Brand Voice',
      viewBrandVoice: 'View brand voice',
      references: 'References',
      slug: 'Slug',
      seoTitle: 'SEO Title',
      metaDescription: 'Meta Description',
      geo: 'Geolocation',
      lastUpdated: 'Last updated:',
    },
    seoTabs: {
      seo: 'SEO',
      social: 'Social',
      schema: 'Schema',
    },
    imageGallery: {
      title: 'Images',
      aiFallbackBadge: 'AI (stock unavailable)',
      stockFailedTitle: 'Stock images unavailable',
      stockFailedDescription:
        'The stock provider failed, so no images were added to this content.',
      coverLabel: 'Cover image',
      sectionLabel: 'Section',
      regenerateTitle: 'Regenerate image',
      customPromptLabel: 'Custom instructions (optional)',
      customPromptPlaceholder: 'Ex: Use warmer tones, add more contrast...',
      regenerateButton: 'Regenerate',
      regenerating: 'Regenerating...',
      cancel: 'Cancel',
      regenerateSuccess: 'Image regenerated successfully',
      regenerateError: 'Failed to regenerate image: {{message}}',
      generateNew: 'New image',
      generateSuccess: 'New image generated successfully',
      generateError: 'Failed to generate image: {{message}}',
      generating: 'Generating...',
      contextDialogTitle: 'Generate image for section',
      contextDialogDescription: 'Select which section the image will illustrate so it matches the content context.',
      selectSection: 'Select a section',
      customContext: 'Or describe the context manually',
      customContextPlaceholder: 'E.g.: A comparison chart of SEO vs GEO strategies...',
      generateForSection: 'Generate image',
      generateAndInsert: 'Generate & insert',
      insertInContent: 'Insert in content',
      zoomLabel: 'Zoom',
      regenerateLabel: 'Regenerate',
      deleteLabel: 'Delete image',
      deleteConfirmTitle: 'Delete image?',
      deleteConfirmDescription: 'This will remove the image from the content. This action cannot be undone.',
      deleteConfirm: 'Delete',
      deleteSuccess: 'Image deleted successfully',
      deleteError: 'Failed to delete image: {{message}}',
      emptyTitle: 'No images generated',
      emptyDescription: 'The initial run produced no images. Generate one to illustrate the content.',
    },
    seoMetadata: {
      updateSuccess: 'SEO metadata updated',
      updateError: 'Failed to update SEO metadata: {{message}}',
    },
    export: {
      download: 'Download',
      loadingTags: 'Loading tags...',
      htmlFull: 'HTML (complete)',
      json: 'JSON (structured)',
      htmlSimple: 'HTML (simple)',
    },
    editor: {
      save: 'Save',
      saving: 'Saving...',
      saved: 'Content saved successfully',
      saveError: 'Failed to save content',
      unsavedChanges: 'Unsaved changes',
      richText: 'Rich Text',
      markdown: 'Markdown',
    },
    languages: {
      es: 'Spanish',
      en: 'English',
      pt: 'Portuguese',
    },
    reliability: {
      analyzing: 'Analyzing reliability...',
      skipped: 'No sources to analyze',
      failed: 'Analysis failed',
      retry: 'Retry',
      analyze: 'Analyze',
      overallConfidence: 'Overall Confidence',
      high: 'High',
      medium: 'Medium',
      low: 'Low',
      internalSource: 'Internal Source',
      web: 'Web',
      inferred: 'Inferred',
      searchPlaceholder: 'Search claims...',
      filterAll: 'All',
      claimsCount: '{{count}} claims analyzed',
      viewDetails: 'View details',
      close: 'Close',
      source: 'Source',
      confidence: 'Confidence',
      excerpt: 'Source excerpt',
      articlePhrase: 'Article',
      sourcePhrase: 'Source',
      noSourceMatch: 'No source match found',
      fix: 'Fix',
      fixAll: 'Fix all ({{count}})',
      fixing: 'Fixing...',
      fixSuccess: '{{count}} claim(s) corrected successfully',
      fixNoData: 'No data found to correct claims',
      fixError: 'Failed to fix claims: {{message}}',
      fixStatusFixed: 'Fixed',
      fixStatusNoData: 'No data',
      fixStatusUnchanged: 'Unchanged',
      fixStatusError: 'Error',
    },
    tags: {
      addTag: 'Add tag',
      edit: 'Edit',
      searchTags: 'Search tags...',
      noTagsFound: 'No results',
      noTagsAvailable: 'No tags available',
      createNewTag: 'Create new tag',
      tagNamePlaceholder: 'Tag name',
      tagColor: 'Color:',
      cancel: 'Cancel',
      create: 'Create',
    },
    folder: {
      assign: 'Assign folder',
      change: 'Change folder',
      searchFolders: 'Search folders...',
      noFoldersFound: 'No results',
      noFoldersAvailable: 'No folders available',
      createNewFolder: 'Create new folder',
      folderNamePlaceholder: 'Folder name',
      folderColor: 'Color:',
      cancel: 'Cancel',
      create: 'Create',
    },
  },
} as const

